import { message, Modal, Upload } from 'antd';
import React, { useState } from 'react';
import { LIST_ACCEPT, LIST_ACCEPTNOTPDF } from './constant';
import { AiOutlineFileJpg, AiOutlineFilePdf, AiOutlineFileText, AiOutlineUpload } from 'react-icons/ai';
import { BsFiletypePng } from 'react-icons/bs';
import BtnDeleteUC from '../../components/Form/BtnDeleteUC';
import { getPreviewUrl } from '../../utils/file';
import { urlAttachFileRc } from '../../config/axios-rc';

const UploadForm = (props) => {
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const { handleUpload, handleDelete, attachFile, isNotPDF = false, isReadOnly = false } = props
    const urlAttachFile = urlAttachFileRc()
    const { Dragger } = Upload;
    const _LIST_ACCEPT = (isNotPDF ? LIST_ACCEPTNOTPDF.toString() : LIST_ACCEPT.toString())
    const propsUpload = {
        name: 'file',
        multiple: false,
        showUploadList: false,
        accept: _LIST_ACCEPT,
        beforeUpload: (file) => {
            //if (!LIST_ACCEPT.includes(file.type) || (file.size / 1024 / 1024 > 2)) {
            if (!_LIST_ACCEPT.includes(file.type) || (file.size / 1024 / 1024 > 2)) {
                if (isNotPDF) {
                    message.error('แนบไฟล์ได้เฉพาะ .jpg, .png และขนาดไม่เกิน 2MB');
                } else {
                    message.error('แนบไฟล์ได้เฉพาะ .jpg, .png หรือ .pdf และขนาดไม่เกิน 2MB');
                }
            }
            return false;
        },
        onChange(info) {
            const { status } = info.file;
            if (status !== 'uploading') {
                // console.log(info.file, info.fileList);
                if (_LIST_ACCEPT.includes(info.file.type) && (info.file.size / 1024 / 1024 < 2)) {
                    onUpload(info.file)
                }
            }
            if (status === 'done') {
                message.success(`${info.file.name} file uploaded successfully.`);
            } else if (status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        },
        onDrop(e) {
            console.log('Dropped files', e.dataTransfer);
        },
    };

    const IconFile = (type) => {
        // console.log('type', type)
        if (type) {
            if (type.includes('jpg') || type.includes('jpeg')) {
                return <AiOutlineFileJpg className='icon-upload' />
            }
            if (type.includes('png')) {
                return <BsFiletypePng className='icon-upload' />
            }
            if (type.includes('pdf')) {
                return <AiOutlineFilePdf className='icon-upload' />
            }
        }
        return <AiOutlineFileText className='icon-upload' />
    }

    const onUpload = (file) => {
        const attachFile = {
            fileSize: file.size,
            fileName: file.name,
            fileType: file.type,
            file
        }
        handleUpload(attachFile)
    }

    const onClickToView = async (file) => {
        console.log('onClickToView', file)
        if (!file.filePath && !file.preview) {
            file.preview = await getPreviewUrl(file);
        }

        setPreviewImage((file.filePath && (urlAttachFile + file.filePath)) || file.preview);
        setPreviewOpen(true);
    }

    const handleCancel = () => setPreviewOpen(false);

    const modalWidth = window.innerWidth <= 768 ? '100%' : '70%'
    return (
        <>
            {attachFile ?
                <div className='div-upload-view w-full p-3'>
                    <div className="file-item flex w-full justify-between">
                        <div className='item flex items-center'>
                            <div className='upload-file-icon mr-3'>{IconFile(attachFile.fileType)}</div>
                            <div className="flex flex-col">
                                <div className="click-to-view cursor-pointer underline" onClick={() => onClickToView(attachFile)}>{attachFile.fileName}</div>
                                <div className="file-size">{attachFile.fileSize ? (attachFile.fileSize / 1024 / 1024).toFixed(2) + ' MB' : ''}</div>
                            </div>

                        </div>
                        <BtnDeleteUC disabled={attachFile.isCanNotDelete === false || isReadOnly} handleDelete={handleDelete} />
                    </div>
                </div> :
                <Dragger {...propsUpload} className='w-full'>
                    <p className="ant-upload-drag-icon">
                        <AiOutlineUpload className='icon-upload-form margin-auto' />
                    </p>
                    <p className="ant-upload-text">ลากไฟล์​วางที่นี่ หรือคลิกเพื่ออัปโหลดไฟล์</p>
                    <p className="ant-upload-hint">
                        {isNotPDF && (
                            <>แนบไฟล์ได้เฉพาะ .jpg, .png และขนาดไม่เกิน 2MB</>

                        )}
                        {!isNotPDF && (
                            <>แนบไฟล์ได้เฉพาะ .jpg, .png หรือ .pdf และขนาดไม่เกิน 2MB</>

                        )}
                    </p>
                </Dragger>
            }
            <Modal open={previewOpen} width={modalWidth} footer={null} onCancel={handleCancel} title={attachFile && attachFile.fileName}>
                {attachFile && attachFile.fileType && attachFile.fileType.includes('pdf') ?
                    <iframe src={previewImage} className='w-full top-0 left-0 bottom-0 right-0 border-none'
                        title={attachFile.fileName}
                        style={{ height: "70vh" }}
                        allowFullScreen />
                    :
                    <img alt="example" className='w-full' src={previewImage} />
                }
            </Modal>
        </>
    )
}
export default UploadForm;